import { getDatabase, ref, update } from 'firebase/database';
import { doc, setDoc } from 'firebase/firestore';

import { HomeworkOnPageType } from 'shared/types/notebookTypes';

import { firestore } from '../Common/Firebase';
import { throwErrorRollbar } from '../index';

export const saveContentString = async (
  userSubject: string,
  userMail: string,
  currentSheetId: string,
  firstContent: string,
  secondContent: string,
  firstDate: string,
  secondDate: string,
  firstPageOrder: number,
  secondPageOrder: number,
  isSquared: boolean,
  nextId?: string | null,
  prevId?: string | null,
  firstReview?: boolean,
  secondReview?: boolean,
  firstPageHomework?: HomeworkOnPageType,
  secondPageHomework?: HomeworkOnPageType,
) => {
  const db = getDatabase();
  const dbUserRef = ref(db, `Notebooks/${userMail}/${userSubject}`);
  const userRef = doc(firestore, 'notebook-content/', userMail);

  await update(dbUserRef, {
    [currentSheetId]: {
      firstSheet: {
        content: currentSheetId,
        imageUrl: null,
        isReviewed: firstReview ?? false,
        lastModifiedDate: firstDate,
        order: firstPageOrder,
        homework: firstPageHomework ?? null,
      },
      secondSheet: {
        content: currentSheetId,
        imageUrl: null,
        isReviewed: secondReview ?? false,
        lastModifiedDate: secondDate,
        order: secondPageOrder,
        homework: secondPageHomework ?? null,
      },
      id: currentSheetId,
      spreadOrder: 1,
      widthFullImg: 100,
      imageUrl: null,
      isSquared,
      nextId: `${nextId ?? null}`,
      prevId: `${prevId ?? null}`,
    },
  }).then(() => {});

  await setDoc(
    userRef,
    {
      [userSubject]: {
        [currentSheetId]: {
          firstContent,
          secondContent,
        },
      },
    },
    { merge: true },
  )
    .then(() => {})
    .catch(error => {
      console.error('Error adding object ttt to document testUser:', error);
      error.name = 'Error adding object ttt to document testUser:';
      throwErrorRollbar(error);
    });
};
